import React from "react";
import { useSelector } from "react-redux";

import HomeIcon from "@material-ui/icons/Home";
import BusinessIcon from "@material-ui/icons/Business";
import AddBoxIcon from "@material-ui/icons/AddBox";
import ReceiptIcon from "@material-ui/icons/Receipt";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import DoneAllIcon from "@material-ui/icons/DoneAll";

import {
  userGetStartedStepSelector,
  userGetInventoryTypeSelector,
  userChecklistCompletedSelector,
  userGetStartedHasFinishedSelector,
} from "src/store/system/selector";
import type {
  NavigatorEntry,
  NavigatorEntryHrefRendererProps,
} from "src/interfaces/navigator";
import { userRoleSelector } from "src/store/system/selector";

import NavigatorItem from "src/components/Navigator/NavigatorItem";
import { useRecordEvent } from "src/hooks/useRecordEvent";

function GetStartedNavigatorItem({
  active,
  entry,
  collapsed,
}: NavigatorEntryHrefRendererProps) {
  const hasFinished = useSelector(userGetStartedHasFinishedSelector);
  const initialStep = useSelector(userGetStartedStepSelector);
  const checklistCompleted = useSelector(userChecklistCompletedSelector);

  if (hasFinished) return null;
  if (checklistCompleted) return null;

  return (
    <NavigatorItem
      id={entry.id}
      Icon={entry.Icon}
      primary={
        initialStep &&
        initialStep !== "inventory:how-do-you-account-for-your-inventory"
          ? "Resume Set Up"
          : entry.title
      }
      to={entry.href}
      active={active}
      collapsed={collapsed}
    />
  );
}

function AdminNavigatorItem({ entry, dispatch, collapsed }) {
  const recordEvent = useRecordEvent();

  const userRole = useSelector(userRoleSelector);

  return (
    <NavigatorItem
      id={entry.id}
      onClick={() => {
        recordEvent({
          type: "feature-adoption",
          feature: "navigation-selection",
          element: entry.id,
        });
        dispatch(entry.dialog);
      }}
      Icon={entry.Icon}
      primary={entry.title}
      disabled={userRole === "viewer"}
      collapsed={collapsed}
    />
  );
}

function AddInventoryNavigatorItem(props) {
  const inventoryType = useSelector(userGetInventoryTypeSelector);

  if (inventoryType === "cash") return null;

  return <AdminNavigatorItem {...props} />;
}

export const navigation: Array<NavigatorEntry> = [
  {
    id: "get-started",
    title: "Get Started",
    Icon: CheckBoxIcon,
    href: "/get-started",
    render: (props) => <GetStartedNavigatorItem {...props} />,
  },
  {
    id: "management",
    title: "Dashboards",
    Icon: HomeIcon,
    href: "/management",
  },
  {
    id: "transaction-details",
    title: "Transaction Details",
    Icon: ReceiptIcon,
    href: "/transaction-details",
  },
  {
    id: "reconciliation",
    title: "Reconciliation",
    Icon: DoneAllIcon,
    href: "/reconciliation",
  },
  {
    id: "reseller_reports",
    title: "Reseller Reports",
    Icon: BusinessIcon,
    href: "/reports",
  },
  {
    id: "report_sale",
    dialog: "report_sale",
    title: "Report Sale",
    Icon: TrendingUpIcon,
    render: (props) => <AdminNavigatorItem {...props} />,
  },
  {
    id: "add_inventory",
    dialog: "add_inventory",
    title: "Add Inventory",
    Icon: AddBoxIcon,
    render: (props) => <AddInventoryNavigatorItem {...props} />,
  },
  {
    id: "add_expense",
    dialog: "add_expense",
    title: "Add Transaction",
    Icon: CreditCardIcon,
    render: (props) => <AdminNavigatorItem {...props} />,
  },
  {
    id: "integrations",
    title: "Integrations",
    Icon: CheckBoxIcon,
    href: "/integrations",
  },
];
